import {AttributeLink} from '@acng/frontend-stargazer';
import {onSubmit} from '../../layout/service/worker.js';
import {assign} from '../../core/service/location.js';
import {valid, signup} from '../service/signup.js';

/**
 * Make a signup form.
 *
 * {@link valid | Validate the form data} when assertions are built.
 *
 * Any possible outcome is implicitly handled by
 * {@link signup | the signup service}.
 *
 * ## Stargazer
 *
 * | Phase | Description                      |
 * | ----- | -------------------------------- |
 * | Link  | Add the "submit" event listener. |
 *
 * @example
 *
 * ```html
 * <form onsubmit-signup>
 *   <input name="nickname" />
 *   <input name="email" />
 *   <input name="password" />
 *   <input type="submit" />
 * </form>
 * ```
 *
 * @group DOM Attribute
 */
const name = 'onsubmit-signup';

AttributeLink(name, (form, value) => {
  onSubmit(form, async (form, data) => {
    ASSERT: valid(data);
    await signup(form, data);

    if (value) {
      assign(form, value);
    }
  });
});

export {name as ACTION_SIGNUP};
